var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinResume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin-move") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 20 0 20 26 0 26"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-move"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0017179,0 C4.49063735,0 0,4.53775224 0,10.1109181 C0,14.172658 2.42226422,17.9772818 4.75863254,20.8125084 C7.09500086,23.6477349 9.43136918,25.5378859 9.43136918,25.5378859 L10.0017179,26 L10.5720667,25.5378859 C10.5720667,25.5378859 12.908435,23.6477349 15.2448033,20.8125084 C17.5811716,17.9772818 20,14.172658 20,10.1109181 C20,4.53775224 15.5127985,0 10.0017179,0",
    id: "Fill-1",
    fill: "#4A90E2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_play_1939965-copy-2",
    transform: "translate(4.000000, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81449345,4.33010116 L1.30604347,0.13643244 C0.750974998,-0.221820666 0,0.168043009 0,0.810791229 L0,9.1875918 C0,9.84087688 0.750974998,10.2202037 1.30604347,9.86195059 L7.81449345,5.66828188 C8.30425976,5.36271305 8.30425976,4.64620684 7.81449345,4.33010116 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_play_1939965-copy-3",
    transform: "translate(9.000000, 5.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81449345,4.33010116 L1.30604347,0.13643244 C0.750974998,-0.221820666 0,0.168043009 0,0.810791229 L0,9.1875918 C0,9.84087688 0.750974998,10.2202037 1.30604347,9.86195059 L7.81449345,5.66828188 C8.30425976,5.36271305 8.30425976,4.64620684 7.81449345,4.33010116 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinResume);
export default __webpack_public_path__ + "static/media/pin-resume.f7778f6853c1fdb2cfc90b10e7d74ddc.svg";
export { ForwardRef as ReactComponent };